import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  Pedestrian: 0,
  Bicycle: 0,
  Transit: 0,
  Auto: 0,
  Freight: 0
}

const modalTiers = createSlice({
  name: 'modalTiers',
  initialState,
  reducers: {
    setModalTiers(state, action) {
      const { field, value } = action.payload
      state[field] = value
    },
    resetModalTiers(state) {
      return initialState
    },
    setAllModalTiers(state, action) {
      return action.payload
    }
  }
})

export const { setModalTiers, resetModalTiers, setAllModalTiers } =
  modalTiers.actions
export default modalTiers.reducer
